import React from "react"

import CryptoIcoLanding from "../pages"

const authRoutes = [
    {path: "/", component: CryptoIcoLanding},
]

export {authRoutes}
